module.exports = __webpack_public_path__ + "static/img/rank_70.610c8ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_70.png
// module id = 5fyB
// module chunks = 1